<template>
    <v-dialog
        v-if="showDialog"
        :value="showDialog"
        :width="820"
        content-class="dialog-wrapper rounded-lg"
        @input="close_modal"
    >
        <div ref="scrollRef"></div>
        <TaskView
            :task-id="taskId"
            :is-template="isTemplate"
            :client-id="clientId"
            :title="title"
            :date="date"
            :topic-id="topicId"
            :is-task-button="isTaskButton"
            :is-job-template="isJobTemplate"
            :is-workflow-template="isWorkflowTemplate"
            :is-temporary-client-task="isTemporaryClientTask"
            :temporary-client-task="temporaryClientTask"
            :available-related-tasks="availableRelatedTasks"
            :project-id="projectId"
            :time-entry="timeEntry"
            :company-id="companyId"
            :pseudo-users="pseudoUsers"
            @close="close_modal"
            @save="save_task"
            @delete="$emit('delete', $event)"
            @scrollDown="scrollDown"
        ></TaskView>
    </v-dialog>
</template>

<script>
import { ref } from "@vue/composition-api";
import TaskView from "../../views/Task/TaskView";
import TaskModule from "../../store/modules/task";

export default {
    name: "TaskDialog",
    components: {
        TaskView
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true
        },
        taskId: {
            type: [String, Number],
            required: true
        },
        isTemplate: {
            type: Boolean,
            default: false
        },
        clientId: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ""
        },
        topicId: {
            type: Number,
            default: null
        },
        date: {
            type: String,
            default: null
        },
        isJobTemplate: {
            type: Boolean,
            default: false
        },
        isWorkflowTemplate: {
            type: Boolean,
            default: false
        },
        isProjectTasks: {
            type: Boolean,
            default: false
        },
        isTemporaryClientTask: {
            type: Boolean,
            default: false
        },
        temporaryClientTask: {
            type: Object,
            required: false,
            default: null
        },
        availableRelatedTasks: {
            type: Array,
            default: () => []
        },
        isTaskButton: {
            type: Boolean,
            default: false
        },
        companyId: {
            type: Number,
            default: 0
        },
        pseudoUsers: {
            type: Array,
            default: () => []
        },
        timeEntry: {
            type: Object,
            default: null
        },
        projectId: {
            type: Number,
            default: null
        }
    },
    setup(props, ctx) {
        const { closeTask } = TaskModule();
        const scrollRef = ref(null);

        const close_modal = function(params) {
            if (props.isTemporaryClientTask) ctx.emit("close", params);
            else closeTask();
        };

        const save_task = task => {
            if (props.isTemporaryClientTask) ctx.emit("save", task);
        };

        const scrollDown = function(ev) {
            let scrollY = ev.task_content_height + 198 - scrollRef.value.parentElement.clientHeight;
            setTimeout(function() {
                scrollRef.value.parentElement.scrollTo({ top: scrollY, left: 0, behavior: "smooth" });
            }, 200);
        };

        return {
            scrollRef,
            close_modal,
            save_task,
            scrollDown
        };
    }
};
</script>
<style scoped>
::v-deep .dialog-wrapper {
    align-self: baseline;
    margin-top: 50px;
    max-height: calc(100% - 120px);
}
</style>
